import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const SPACES = [
  {
    icon: 'ri-whatsapp-line',
    title: 'Groupe WhatsApp des marchands',
    desc: 'Entraide quotidienne entre commerçants : tarifs, fournisseurs, astuces terrain.',
    cta: 'Rejoindre le groupe',
    tint: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-discord-line',
    title: 'Canal technique',
    desc: 'Discussions API, intégrations, bugs et demandes de fonctionnalités.',
    cta: 'Ouvrir le canal',
    tint: 'bg-secondary-100 text-secondary-900',
  },
  {
    icon: 'ri-youtube-line',
    title: 'Tutoriels vidéo',
    desc: 'Des démonstrations courtes, module par module, pour aller vite.',
    cta: 'Voir les vidéos',
    tint: 'bg-accent-100 text-accent-800',
  },
];

const EVENTS = [
  { date: '12 nov. 2026', title: 'Atelier : facturer sans erreur', place: 'En ligne · 18h00', tag: 'Facturation' },
  { date: '26 nov. 2026', title: 'Rencontre marchands Casablanca', place: 'Casablanca · 15h00', tag: 'Terrain' },
  { date: '10 déc. 2026', title: 'API Zifek : intégrer son stock', place: 'En ligne · 17h30', tag: 'Technique' },
];

const STORIES = [
  {
    name: 'Salma · Riad Dar Zaman',
    text: 'Avant, je tenais mes réservations sur un cahier. Aujourd’hui tout est dans Zifek, et mes factures sont prêtes en un clic.',
  },
  {
    name: 'Youssef · Atelier Cuir 212',
    text: 'Le carnet de crédit a changé ma gestion. Je sais exactement qui me doit combien, sans calculer le soir.',
  },
  {
    name: 'Nadia · Épicerie Al Baraka',
    text: 'La caisse et le stock sont liés. Je ne vends plus un produit que je n’ai pas, et mes alertes arrivent sur le téléphone.',
  },
];

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar forceScrolled />

      <header className="pt-24 md:pt-32 pb-10 px-4 md:px-6 lg:px-10 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
            <i className="ri-team-line"></i>Communauté
          </span>
          <h1 className="mt-4 text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight max-w-3xl">
            Vous n’êtes pas seul derrière votre comptoir
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">
            Des milliers de commerçants, artisans et indépendants utilisent Zifek chaque jour. Partagez,
            apprenez, et faites avancer le produit avec nous.
          </p>

          <div className="mt-7 grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { value: '4 800+', label: 'Commerces actifs' },
              { value: '12 000+', label: 'Documents émis' },
              { value: '24', label: 'Villes couvertes' },
              { value: '< 2 h', label: 'Délai de réponse' },
            ].map((s) => (
              <div key={s.label} className="bg-background-50 border border-background-200/70 rounded-lg p-4">
                <p className="text-xl md:text-2xl font-bold font-heading text-foreground-950">{s.value}</p>
                <p className="text-[11px] text-foreground-500 mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </header>

      <main className="px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="max-w-6xl mx-auto space-y-12">
          <section>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950 mb-4">Rejoindre un espace</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {SPACES.map((s) => (
                <div key={s.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5 flex flex-col">
                  <span className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${s.tint}`}>
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-sm font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed flex-1">{s.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-700">
                    {s.cta}<i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              ))}
            </div>
          </section>

          <section className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-6">
            <div>
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950 mb-4">Ils racontent</h2>
              <div className="space-y-3">
                {STORIES.map((st) => (
                  <article key={st.name} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                    <i className="ri-double-quotes-l text-xl text-accent-300"></i>
                    <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{st.text}</p>
                    <p className="mt-3 text-xs font-semibold text-foreground-900">{st.name}</p>
                  </article>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950 mb-4">Prochains rendez-vous</h2>
              <div className="bg-background-50 border border-background-200/70 rounded-lg divide-y divide-background-200/70 overflow-hidden">
                {EVENTS.map((e) => (
                  <div key={e.title} className="p-4">
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <span className="text-[11px] font-semibold text-primary-700">{e.date}</span>
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[10px] font-semibold">
                        {e.tag}
                      </span>
                    </div>
                    <p className="text-sm font-medium text-foreground-900">{e.title}</p>
                    <p className="text-[11px] text-foreground-500 mt-0.5">{e.place}</p>
                  </div>
                ))}
              </div>

              <div className="mt-4 bg-primary-500 rounded-lg p-5">
                <h3 className="text-base font-bold font-heading text-background-50">Proposez une fonctionnalité</h3>
                <p className="mt-1 text-sm text-background-50/80">
                  Les meilleures idées viennent du terrain. Décrivez votre besoin, on l’étudie chaque semaine.
                </p>
                <Link
                  to="/dashboard/apps/customer-support"
                  className="mt-4 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-background-50 text-primary-700 text-sm font-semibold no-underline hover:bg-background-100 transition-colors"
                >
                  <i className="ri-lightbulb-line"></i>Envoyer une idée
                </Link>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}